import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GlobalModal from '../GlobalModal/GlobalModal';

const CancelSubscriptionModal = ({ 
  show, 
  onClose, 
  onConfirm
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector(state => state.user.user);

  const handleYesClick = () => {
    // Check if user has SME plan subscription
    const isSMEPlan = user.subscriptionDetail.plan.id === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH || 
                      user.subscriptionDetail.plan.id === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR;

    // Navigate based on subscription type
    if (isSMEPlan) {
      navigate('/subscription-downgrade');
    } else {
      navigate('/discount-offer');
    }
    onClose();
  };

  return (
    <GlobalModal
      show={show}
      onClose={onClose}
      title={t('cancelSubscription.title', 'Do you wasdasdant to cancel your subscription?')}
      primaryButtonText={t('Yes')}
      secondaryButtonText={t('No')}
      primaryButtonAction={handleYesClick}
      secondaryButtonAction={onClose}
    />
  );
};

export default CancelSubscriptionModal; 